module.exports = __webpack_public_path__ + "public/files/img/noor2.fd6d6cb6.jpg";